<template>
  <div class="home mt-5">
    <Suspense>
      <Dashboard />
    </Suspense>
  </div>
</template>

<script setup>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

</script>
